import {RouteShape} from './routeshape.model';
import decode_google_map_polyline from 'decode-google-map-polyline';
import {Route} from './route.model';
import {Vehicle} from './vehicle.model';
import {Vehiclecontainer} from './vehiclecontainer.model';
import {SettingsDataService} from '../settings-data.service';
import {Stop} from './stop.model';
import {StopPrediction} from './stopprediction.model';
import {TrackVehicle} from './track-vehicle.model';

export class HereMapConverter {


  static equalsRoute(route1: Route, route2: Route): boolean {
    return route1.providerId === route2.providerId && route1.routeId === route2.routeId;
  }

// compare the routeIDs of the two given routes, useful for sorting
  static compareFn(route1: Route, route2: Route): number {
    let result: number;

    result = route1.providerId.localeCompare(route2.providerId);
    if (result === 0) {
      result = parseInt(route1.routeId, 10) - parseInt(route2.routeId, 10);

      if (result === 0 || Number.isNaN(result)) {
        return route1.routeId.localeCompare(route2.routeId);
      } else {
        return result;
      }
    } else {
      return result;
    }
  }


  static getIcon(): H.map.Icon {
    return new H.map.Icon('<svg width="17" height="17" ' +
      'xmlns="http://www.w3.org/2000/svg">' +
      '<rect stroke="black" fill="#1b468d" x="1" y="1" width="15" ' +
      'height="1em" /><text x="9" y="12" font-size="8pt" ' +
      'font-family="Arial" font-weight="bold" text-anchor="middle" ' +
      'fill="white">S</text></svg>', {anchor: {x: 8, y: 8}, crossOrigin: false});
  }

  static matches(stop1: Stop, providerId: string, stopId: string): boolean {
    return stop1.providerId === providerId && stop1.stopId === stopId;
  }

  static equals(stop1: Stop, stop2: Stop): boolean {
    return stop1.providerId === stop2.providerId && stop1.stopId === stop2.stopId;
  }

  static convert(prediction: StopPrediction): Stop {
    const stop = new Stop();
    stop.lat = prediction.lat;
    stop.lon = prediction.lon;
    stop.stopDescription = prediction.name;
    stop.providerId = prediction.providerId;
    stop.stopId = prediction.stopId;

    return stop;
  }

  static getShape(routeshape: RouteShape): H.map.Polyline[] {
    return routeshape.shape.map((item) => this.decodeShape(item));
  }

  static decodeShape(item: string): H.map.Polyline {
    const linestring = new H.geo.LineString();
    decode_google_map_polyline(item).forEach(function (point) {
      linestring.pushPoint(point);
    });

    return new H.map.Polyline(linestring, {style: {lineWidth: 1, strokeColor: 'blue'}});
  }

  static getStops(routeshape: RouteShape, iconSize: number, minZoom: number): H.map.Object[] {
    return routeshape.stops.map((item) => this.getStopMarker(item, iconSize, minZoom));
  }

  static getMarker(vehicle: Vehicle, iconSize: number, color: string, transparent: boolean, trackVehicle: TrackVehicle): H.map.Object {
    let zIndex = 10;
    if (!transparent) {
      zIndex = 15;
    }
    return new H.map.Marker({lat: vehicle.lat, lng: vehicle.lon}, {
      icon: this.getNewIcon(vehicle, iconSize * 2, color, transparent, trackVehicle),
      zIndex: zIndex
    });
  }

  static getNewIcon(vehicle: Vehicle, iconSize: number, color: string, transparent: boolean, trackVehicle: TrackVehicle): H.map.Icon {
    let line = 'black';
    if (transparent && !(trackVehicle !== null
      && trackVehicle !== undefined && trackVehicle.vehicleId.localeCompare(vehicle.vehicleId) === 0)) {
      color = color.replace(')', ', 0.35);');
      line = '#ffffffAA';
    }

    return new H.map.Icon(`<svg xmlns="http://www.w3.org/2000/svg"
width="${iconSize}em" height="${iconSize}em" overflow="visible" fill="white" viewBox="0 0 50 50">
   <svg height="50" width="50">
     <polygon transform="rotate(${vehicle.heading} 25 25)"
      transform-box="fill-box" points="25,15 45,35 5,35"
     style="fill:${color};stroke:${line};stroke-width:1" />
    <text x="25" y="32" text-anchor="middle" fill="${line}" font-size="9" font-weight="bolder">${vehicle.vehicleId}</text>
    </svg>
</svg>
`, {anchor: {x: iconSize * 8, y: iconSize * 8}, crossOrigin: false});
  }

  static getMarkers(vehicleContainer: Vehiclecontainer,
                    iconSize: number, settings: SettingsDataService, transparent: boolean, trackVehicle: TrackVehicle): H.map.Object[] {
    return vehicleContainer.veh.map((item) => this.getMarker(item, iconSize, settings.getColor(item.routeId), transparent, trackVehicle));
  }

  static getStopMarker(stop: Stop, iconSize: number, minZoom: number): H.map.Object {
    return new H.map.Marker({lat: stop.lat, lng: stop.lon}, {
      icon: this.getStopMediumIcon(stop, iconSize),
      min: minZoom,
      data: {providerId: stop.providerId, stopId: stop.stopId, stopDescription: stop.stopDescription, route: stop.route}
    });
  }

  static getStopPinnedMarker(stop: Stop, iconSize: number): H.map.Object {
    return new H.map.Marker({lat: stop.lat, lng: stop.lon}, {
      icon: this.getStopPinnedIcon(stop, iconSize * 1.5),
      data: {providerId: stop.providerId, stopId: stop.stopId, stopDescription: stop.stopDescription, route: stop.route},
      zIndex: 5
    });
  }

  static getStopMediumIcon(stop: Stop, iconSize: number): H.map.Icon {
    return new H.map.Icon(`<svg xmlns="http://www.w3.org/2000/svg"
      width="${iconSize}em" height="${iconSize}em">
      <circle cx="${iconSize / 2}em" cy="${iconSize / 2}em" r="${iconSize / 2}em" stroke="black" fill-opacity="0.5" fill="blue" /></svg>
`, {
      crossOrigin: false
    });
  }

  static getStopPinnedIcon(stop: Stop, iconSize: number): H.map.Icon {
    return new H.map.Icon(`<svg  xmlns="http://www.w3.org/2000/svg"
width="${iconSize}em" height="${iconSize}em" overflow="visible" viewBox="0 0 32 32">
	<svg height="32" width="32" class="star rating" data-rating="1" fill="#ff8800">
    <path d="M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118
  l11.547-1.2L16.026,0.6L20.388,10.918z"/>
  </svg>
</svg>
`, {
      crossOrigin: false
    });
  }

}
